<div class="custom-select-container">
    <div class="custom-select-wrapper">
        <brand-form-select
            [customError]="customError()"
            [label]="label()"
            [optionsObject]="states"
            [class]="'custom-select'"
            name="state"
            (brandSelectChange)="onBrandSelectChange($event)"
            [errorIconImageUrl]="errorIconImageUrl()"
        >
        </brand-form-select>
    </div>
</div>
